import { render, staticRenderFns } from "./ItemAvatar.vue?vue&type=template&id=4d494ee4&scoped=true&"
import script from "./ItemAvatar.vue?vue&type=script&lang=ts&"
export * from "./ItemAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d494ee4",
  null
  
)

export default component.exports